import { randomString } from "./utils/strings";
import { DEFAULT_ROOT_ID_PREFIX } from "./constants";
import { AppIdentifier, appIdentifierToActionPrefixMap } from "./types";
import store from "./redux/store";

/**
 * generateRootID attempts to create a dynamic ID to be
 * used with a HTML element that is relatively unique
 * and will not cause namespace conflicts.
 *
 * E.g. 'zerohash-49vt8y'
 */
export const generateRootID = (appIdentifier?: AppIdentifier): string => {
  if (appIdentifier) return `${DEFAULT_ROOT_ID_PREFIX}-${appIdentifier}-${randomString(6)}`
  return `${DEFAULT_ROOT_ID_PREFIX}-${randomString(6)}`
};

export const dispatchActionBasedOnAppIdentifier = (appIdentifier: AppIdentifier, actionTypeSuffix: string, payload: object) => {
  const actionTypePrefix = appIdentifierToActionPrefixMap.get(appIdentifier)
  const type = `${actionTypePrefix}${actionTypeSuffix}`
  store.dispatch({
    type,
    ...payload,
  })
}


